import React, { useRef, useState, useEffect } from 'react';
import InputMask from 'react-input-mask';

function DataMaskInput({ value, onChange, disabled, className, ...rest }) {
    const dateInputRef = useRef(null);
    const [displayValue, setDisplayValue] = useState(() => toDisplay(value));

    useEffect(() => {
        setDisplayValue(toDisplay(value));
    }, [value]);

    function toDisplay(v) {
        if (!v) return '';
        const [year, month, day] = v.split('-');
        if (!day || !month || !year || year.length !== 4) return '';
        return `${day}/${month}/${year}`;
    }

    function handleMaskChange(e) {
        const raw = e.target.value;
        setDisplayValue(raw);
        const cleaned = raw.replace(/\D/g, '');
        if (cleaned.length === 8) {
            const actualValue = `${cleaned.substring(4)}-${cleaned.substring(2, 4)}-${cleaned.substring(0, 2)}`;
            onChange({ target: { value: actualValue, name: rest.name } });
        } else if (cleaned.length === 0) {
            onChange({ target: { value: '', name: rest.name } });
        }
    }

    function handleNativeChange(e) {
        const nativeDate = e.target.value;
        if (!nativeDate) return;
        setDisplayValue(toDisplay(nativeDate));
        onChange({ target: { value: nativeDate, name: rest.name } });
    }

    function handleDatePicker() {
        if (disabled) return;
        dateInputRef.current?.showPicker?.();
        dateInputRef.current?.click();
    }

    function handleClear() {
        setDisplayValue('');
        onChange({ target: { value: '', name: rest.name } });
    }

    return (
        <div style={{ position: 'relative' }}>
            <div className="input-group input-group-sm">
                <InputMask
                    mask="99/99/9999"
                    value={displayValue}
                    onChange={handleMaskChange}
                    disabled={disabled}
                >
                    {(inputProps) => (
                        <input {...inputProps} {...rest} className={`form-control form-control-sm${className ? ' ' + className : ''}`} />
                    )}
                </InputMask>
                <button
                    type="button"
                    className="btn btn-outline-info btn-sm"
                    onClick={handleDatePicker}
                    disabled={disabled}
                    title="Selecionar data"
                >
                    <i className="bi bi-calendar3"></i>
                </button>
                {value && (
                    <button
                        type="button"
                        className="btn btn-outline-secondary btn-sm"
                        onClick={handleClear}
                        disabled={disabled}
                        title="Limpar data"
                    >
                        <i className="bi bi-x"></i>
                    </button>
                )}
            </div>
            <input
                ref={dateInputRef}
                type="date"
                onChange={handleNativeChange}
                style={{ opacity: 0, position: 'absolute', width: 0, height: 0 }}
                disabled={disabled}
                tabIndex={-1}
            />
        </div>
    );
}

export default DataMaskInput;
